import { parsePhoneNumber } from 'libphonenumber-js'

const parsePhone = (data) => {
    try {
        let phoneNum = parsePhoneNumber(data.phone);
        data.phone = phoneNum.formatNational();
        data.areaCode = '+' + phoneNum.countryCallingCode;
    } catch (e) {
        data.areaCode = '+852';
        data.phone = data.phone.toString().replace('+', '');
        console.warn(e);
    }
    return data;
}

export default {
    parsePhone
};